import React from "react";
import { useNavigate } from "react-router-dom";
import { Button, Result } from "antd";
import { WarningOutlined } from "@ant-design/icons";

const Error403 = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="flex flex-col align-center text-center justify-center vh-100 text-white bg-black">
        <Result
          icon={<WarningOutlined style={{ fontSize: 72 }} />}
          title="403"
          subTitle="You don't have permission to access this page"
        />
        <Button type="default" onClick={() => navigate("/")}>
          Go to Home
        </Button>
      </div>
    </>
  );
};

export default Error403;
